import React, { FunctionComponent, useEffect, useState } from 'react';
import Container from '@material-ui/core/Container';
import styles from "./Common.module.scss";
import { data } from './local';
import { Button, createStyles, makeStyles, Menu, MenuItem, Select, styled, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@material-ui/core';
import { Theme } from '@mui/material/styles';
import { DataGrid, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import AdminSearchBox from './AdminSearchBox';
import { eventEmitter, getadminDetails, getisAdminSelected, getNominatorMail, getToken, getUserGraphId, getUserInfo, setadminDetails, setisAdminExists } from './common';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux'
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlUnstyled, Modal, tableCellClasses, Typography } from '@mui/material';
import { getAdminDetailsBasedonEmail, getAdminList, getNominatorId } from './services';
import { appInsights } from '../AppInsights';
import CircularProgress from '@mui/material/CircularProgress';
import { NotificationAlert } from "../components/NotificationAlert";

var adminList: any;

const AddAdmin: FunctionComponent<any> = () => {
  let history: any = useHistory();

  const [count, Setcount] = useState(0);
  const [alertType, setAlertType] = useState('');
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState<any>('');
  const [token, setToken] = useState<any>(null);
  const [selectedRows, setSelectedRowS] = useState<any>(null);
  
  //  const languageSelected:any = useSelector((state:any) => state.lang);
  const languageSelected: any = useSelector((state: any) => state.lang);
  const languageData: any = data;
  const { VIANominations } = languageData[languageSelected];
  const [openDeleteAdmin, setOpenForDeleteAdmin] = React.useState(false);
  const [openAddAdmin, setOpenForAddAdmin] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [updatedadminLists, setUpdatedAdminList] = useState<any>(null);
  const [isAdminSubmitDisabled, setIsAdminSubmitDisabled] = useState(true);
  //UseEffects
  useEffect(() => {
    getToken().then((token: any) => {
      setToken(token);
    });
  }, [])

  useEffect(() => {
    getAdminList().then((response: any) => {
      if (response != null) {
        let ListOfAdmins = [];
        for (let key in response) {
          ListOfAdmins.push({ id: key, displayName: response[key].lastName + " " + response[key].firstName + " " + response[key].middleName, email: response[key].email, company: response[key].company });
        }
        if (ListOfAdmins.length > 0) {
          adminList = ListOfAdmins;
          setUpdatedAdminList(adminList);
        }
      }
    });
  }, [count])

  const columns: GridColDef[] = [

    { field: 'id', headerName: 'ID', hide: true },
    { field: 'displayName', headerName: 'Name', minWidth: 150, flex: 1 },
    { field: 'email', headerName: 'Email', minWidth: 150, flex: 1 },
    { field: 'company', headerName: 'Company', minWidth: 150, flex: 1 },


  ]
  // Handlers

  const getcorrelationId = () => {
    return sessionStorage.getItem("correlationId");
  }

  //Admin Functionality
  const AddAdminhandleClickOpen = () => {
    let adminData: any = getadminDetails();
    if (adminData != null && adminData.email != null) {
      setOpenForAddAdmin(true);
    }
    else { setOpenForAddAdmin(false); }
  };
  const DeletehandleClickOpen = () => {
    if (selectedRows != null && selectedRows.length > 0) { setOpenForDeleteAdmin(true); }
    else { setOpenForDeleteAdmin(false); }
  };
  const handleClose = () => {
    setOpenForDeleteAdmin(false);
    setOpenForAddAdmin(false);
    setadminDetails('');
  };



  const classes = useStyles();


  const DeleteAdminbuttonHandler = async () => {

    for (let key in selectedRows) {

      let AdminDetails: any = await getAdminDetailsBasedonEmail(selectedRows[key].email);
      AdminDetails.roleId = 2;
      let nominatorId: any = await getNominatorId(AdminDetails);

      if (nominatorId.id > 0) {
        Setcount((count: number) => count + 1);
        
        setUpdatedAdminList(updatedadminLists);
        setAlertContent('Deleted admin successfully.!');
        setSelectionModel([]);
        setAlert(true);
        setAlertType('success');
        appInsights.trackEvent({ name: "AdminDeleted", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId()} })
      }
    }


    setTimeout(() => { setAlert(false); }, 4000);

    Setcount((count: number) => count + 1);
    setUpdatedAdminList(updatedadminLists);

  };
  function AddAdmin() {
    AddAdminButtonHandler();
    setOpenForAddAdmin(false);
  }
  function DeleteAdmin() {
    DeleteAdminbuttonHandler()
    setOpenForDeleteAdmin(false);
  }
  const AddAdminButtonHandler = async () => {
    let adminData: any = await getadminDetails();
    if (!(updatedadminLists.some((item: any) => adminData.email === item.email))) {
      let nominatorId: any = await getNominatorId(adminData);

      if (nominatorId.id > 0) {
        Setcount((count: number) => count + 1);
        setUpdatedAdminList(updatedadminLists);
        setAlertType('success');
        setAlertContent('Added admin successfully.!');
        setAlert(true);
      }
      setTimeout(() => { setAlert(false); }, 4000);
      Setcount((count: number) => count + 1);
      setUpdatedAdminList(updatedadminLists);
      let AdminName = adminData.firstName;
      appInsights.trackEvent({ name: "AdminAdded", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
    }
    else {
      setAlertType('error');
      setAlertContent('You already added this person as admin. Please make another selection');
      setAlert(true);
      setTimeout(() => { setAlert(false); }, 4000);
    }
  }


  // End Of Admin




  const [selectionModel, setSelectionModel] = useState<any>([]);
  



  return (
    <React.Fragment>
      <Container maxWidth={"xl"} >
        <div className={styles.adminPage}>
          {alert && <NotificationAlert state={alert} notificationMessage={alertContent} alertType={alertType} />}
          <h2 className={styles.headerBold}>Add Admin</h2>

          <h2 className={styles.header}>Give Admin privileges to </h2>
          <hr />
          {token && <AdminSearchBox title="Please enter the name here" token={token} />}
          <Button variant="outlined" className={!isAdminSubmitDisabled ? styles.AddAwardeeDisabledBttn : styles.AddAwardeeBttn} onClick={AddAdminhandleClickOpen} disabled={!isAdminSubmitDisabled}>Add as admin</Button>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <h2 className={styles.header}>Admins</h2>
            <span className={styles.floatRightAdmin}>
              <Button variant="outlined" className={styles.AddAwardeeBttn} onClick={DeletehandleClickOpen}>Delete Admin</Button>
            </span>
          </div>
          <hr />
          <Dialog
            open={openAddAdmin}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title" style={{ backgroundColor: '#00338e', fontFamily: 'barlow', color: '#FFFFFF' }} >
              {"Add Admin"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to add this person as Admin?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={styles.messageBoxEditor} onClick={AddAdmin} autoFocus>
                Yes
              </Button>
              <Button className={styles.messageBoxEditor} onClick={handleClose}>No</Button>

            </DialogActions>
          </Dialog>

          <Dialog
            open={openDeleteAdmin}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title" style={{ backgroundColor: '#00338e', fontFamily: 'barlow', color: '#FFFFFF' }}>
              {"Delete Admin"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to delete the selected Admins?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={styles.messageBoxEditor} onClick={DeleteAdmin} autoFocus>
                Yes
              </Button>
              <Button className={styles.messageBoxEditor} onClick={handleClose}>No</Button>

            </DialogActions>
          </Dialog>
          <div style={{ height: 400, width: '100%' }}>
            <DataGrid
              rows={updatedadminLists}
              columns={columns}
              pageSize={5}
              className={classes.root}
              rowsPerPageOptions={[5]}
              selectionModel={selectionModel}
              checkboxSelection
              onSelectionModelChange={(ids) => {
                setSelectionModel(ids);
                const selectedIDs = new Set(ids);
                const selectedRows = adminList.filter((row: any) =>
                  selectedIDs.has(row.id),
                );
                setSelectedRowS(selectedRows);
                
              }}
              // onSelectionModelChange={(newSelectionModel) => {
              //   console.log({newSelectionModel})
              //    setSelectionModel(newSelectionModel);
              //  }}

            />
          </div>

        </div>

        <div>
        </div>
      </Container>
    </React.Fragment>
  );
}


//Css
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      border: 0,

      fontFamily: 'Barlow !important',
      backgroundColor: '#FFFFFF',

      '& .MuiDataGrid-cell:hover': {
        color: '#00338e',
      },
      '& .MuiDataGrid-columnHeader': {
        color: '#FFFFFF',
        backgroundColor: '#00338e',
        fontSize: 'calc(5px + 2vmin)',
        '& .MuiCheckbox-root svg path': {
          color: 'white',
        }
      },
      '& .MuiDataGrid-columnHeadersInner': {
        backgroundColor: '#00338e'
      },
      '& .MuiDataGrid-cell': {
        fontSize: 'calc(2px + 2vmin)'
      },
      '& .MuiCheckbox-root svg path': {
        color: '#00338e',
      }
    },

  }),
);



export default AddAdmin;


